import { storageFactory } from "storage-factory";

const browserStorage = {
  local: storageFactory(() => localStorage),
};

export default browserStorage;
